import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { User } from '@angular/fire/auth';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faDonate, faGear, faIdBadge, faRightFromBracket, faUser } from '@fortawesome/free-solid-svg-icons';

import { AuthService } from '../../../core/auth/auth.service';

@Component({
  selector: 'app-user',
  imports: [CommonModule, FontAwesomeModule, RouterModule],
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss'
})
export class UserComponent {

  //#region Font Awesome Icons
  faUser = faUser;

  faProfile = faIdBadge;
  faDonations = faDonate;
  faSettings = faGear;

  faSignOut = faRightFromBracket;
  //#endregion

  //#region Properties
  user = input<User>();
  //#endregion

  //#region Authentication Materials
  #auth: AuthService = inject(AuthService);
  //#endregion

  //#region Sign Methods
  public onSignOut(): Promise<void> {
    return this.#auth.signOut();
  }
  //#endregion
}
